import {FaChevronRight as RightChevron} from "react-icons/fa"
import styled from "styled-components"

export default styled(RightChevron)`
  transform: rotate(0deg);
`
